import {
  // Navigation
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  ExternalLink,
  House,
  Menu,
  // Actions
  Plus,
  Minus,
  Pencil,
  Trash2,
  Save,
  Download,
  Upload,
  Share2,
  Send,
  Undo,
  Redo,
  Ellipsis,
  EllipsisVertical,
  // Status
  Check,
  X,
  TriangleAlert,
  CircleAlert,
  Info,
  CircleHelp,
  CircleCheck,
  CircleX,
  Ban,
  // Data
  Eye,
  EyeOff,
  Calendar,
  Clock,
  File,
  Folder,
  Image,
  Link,
  // User / Auth
  User,
  Users,
  UserPlus,
  LogOut,
  LogIn,
  Key,
  Lock,
  Shield,
  // Communication
  Mail,
  Phone,
  MessageSquare,
  Bell,
  // Layout
  LayoutGrid,
  List,
  Maximize,
  Minimize,
  // Media
  Play,
  Pause,
  Camera,
  Film,
  Music,
  // Commerce
  CreditCard,
  Tag,
  Receipt,
} from 'lucide-react';

import { createIcon } from './create-icon';

// ── Navigation ──────────────────────────────────────────────────────────────
export const ArrowLeftIcon = createIcon(ArrowLeft, 'ArrowLeftIcon');
export const ArrowRightIcon = createIcon(ArrowRight, 'ArrowRightIcon');
export const ArrowUpIcon = createIcon(ArrowUp, 'ArrowUpIcon');
export const ArrowDownIcon = createIcon(ArrowDown, 'ArrowDownIcon');
export const ChevronLeftIcon = createIcon(ChevronLeft, 'ChevronLeftIcon');
export const ChevronRightIcon = createIcon(ChevronRight, 'ChevronRightIcon');
export const ChevronDownIcon = createIcon(ChevronDown, 'ChevronDownIcon');
export const ChevronUpIcon = createIcon(ChevronUp, 'ChevronUpIcon');
export const ExternalLinkIcon = createIcon(ExternalLink, 'ExternalLinkIcon');
export const HomeIcon = createIcon(House, 'HomeIcon');
export const MenuIcon = createIcon(Menu, 'MenuIcon');

// ── Actions ─────────────────────────────────────────────────────────────────
export const PlusIcon = createIcon(Plus, 'PlusIcon');
export const MinusIcon = createIcon(Minus, 'MinusIcon');
export const PencilIcon = createIcon(Pencil, 'PencilIcon');
export const TrashIcon = createIcon(Trash2, 'TrashIcon');
export const SaveIcon = createIcon(Save, 'SaveIcon');
export const DownloadIcon = createIcon(Download, 'DownloadIcon');
export const UploadIcon = createIcon(Upload, 'UploadIcon');
export const ShareIcon = createIcon(Share2, 'ShareIcon');
export const SendIcon = createIcon(Send, 'SendIcon');
export const UndoIcon = createIcon(Undo, 'UndoIcon');
export const RedoIcon = createIcon(Redo, 'RedoIcon');
export const MoreHorizontalIcon = createIcon(Ellipsis, 'MoreHorizontalIcon');
export const MoreVerticalIcon = createIcon(EllipsisVertical, 'MoreVerticalIcon');

// ── Status / Feedback ───────────────────────────────────────────────────────
export const CheckIcon = createIcon(Check, 'CheckIcon');
export const XIcon = createIcon(X, 'XIcon');
export const AlertTriangleIcon = createIcon(TriangleAlert, 'AlertTriangleIcon');
export const AlertCircleIcon = createIcon(CircleAlert, 'AlertCircleIcon');
export const InfoIcon = createIcon(Info, 'InfoIcon');
export const HelpCircleIcon = createIcon(CircleHelp, 'HelpCircleIcon');
export const CheckCircleIcon = createIcon(CircleCheck, 'CheckCircleIcon');
export const XCircleIcon = createIcon(CircleX, 'XCircleIcon');
export const BanIcon = createIcon(Ban, 'BanIcon');

// ── Data / Content ──────────────────────────────────────────────────────────
export const EyeIcon = createIcon(Eye, 'EyeIcon');
export const EyeOffIcon = createIcon(EyeOff, 'EyeOffIcon');
export const CalendarIcon = createIcon(Calendar, 'CalendarIcon');
export const ClockIcon = createIcon(Clock, 'ClockIcon');
export const FileIcon = createIcon(File, 'FileIcon');
export const FolderIcon = createIcon(Folder, 'FolderIcon');
export const ImageIcon = createIcon(Image, 'ImageIcon');
export const LinkIcon = createIcon(Link, 'LinkIcon');

// ── User / Auth ─────────────────────────────────────────────────────────────
export const UserIcon = createIcon(User, 'UserIcon');
export const UsersIcon = createIcon(Users, 'UsersIcon');
export const UserPlusIcon = createIcon(UserPlus, 'UserPlusIcon');
export const LogOutIcon = createIcon(LogOut, 'LogOutIcon');
export const LogInIcon = createIcon(LogIn, 'LogInIcon');
export const KeyIcon = createIcon(Key, 'KeyIcon');
export const LockIcon = createIcon(Lock, 'LockIcon');
export const ShieldIcon = createIcon(Shield, 'ShieldIcon');

// ── Communication ───────────────────────────────────────────────────────────
export const MailIcon = createIcon(Mail, 'MailIcon');
export const PhoneIcon = createIcon(Phone, 'PhoneIcon');
export const MessageSquareIcon = createIcon(MessageSquare, 'MessageSquareIcon');
export const BellIcon = createIcon(Bell, 'BellIcon');

// ── Layout ──────────────────────────────────────────────────────────────────
export const LayoutGridIcon = createIcon(LayoutGrid, 'LayoutGridIcon');
export const ListIcon = createIcon(List, 'ListIcon');
export const MaximizeIcon = createIcon(Maximize, 'MaximizeIcon');
export const MinimizeIcon = createIcon(Minimize, 'MinimizeIcon');

// ── Media ───────────────────────────────────────────────────────────────────
export const PlayIcon = createIcon(Play, 'PlayIcon');
export const PauseIcon = createIcon(Pause, 'PauseIcon');
export const CameraIcon = createIcon(Camera, 'CameraIcon');
export const FilmIcon = createIcon(Film, 'FilmIcon');
export const MusicIcon = createIcon(Music, 'MusicIcon');

// ── Commerce ────────────────────────────────────────────────────────────────
export const CreditCardIcon = createIcon(CreditCard, 'CreditCardIcon');
export const TagIcon = createIcon(Tag, 'TagIcon');
export const ReceiptIcon = createIcon(Receipt, 'ReceiptIcon');
